import React, { Component } from 'react';
import PropTypes from 'prop-types';
import uuid from 'uuid/v4';
import DesignGalleryItem from './DesignGalleryItem';
import { Designs } from 'apps/find-designers/propTypes';

class DesignGallery extends Component {
    item(_, index) {
        const design = this.props.designs[index];

        if (!design) {
            return <div className="design-gallery__item" key={uuid()} />;
        }

        return (
            <div className="design-gallery__item" key={uuid()}>
                <DesignGalleryItem designerId={this.props.designerId} design={design} />
            </div>
        );
    }

    render() {
        return <div className="design-gallery">{[...Array(3)].map(this.item, this)}</div>;
    }
}

DesignGallery.defaultProps = {
    designs: [],
};

DesignGallery.propTypes = {
    designerId: PropTypes.number,
    designs: Designs.isRequired,
};

export default DesignGallery;



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/Listing/DesignGallery.jsx